import constants from "constants";

const { CPD_STATUSES, REF_TYPES } = constants;

export const groupWebinar = function (object) {
  const isCertificateOfParticipation =
    object.ref_type === REF_TYPES.CERTIFICATE_OF_PARTICIPATION;

  const isNMBI = object.ref_type === REF_TYPES.NMBI;

  const isCustomCertificate = isCertificateOfParticipation || isNMBI;

  let constraints = {
    group_id: {
      presence: {
        allowEmpty: false,
      },
    },
    webinar_type: {
      presence: true,
    },
    webinar_title: {
      presence: {
        allowEmpty: false,
      },
    },
    status: {
      presence: true,
    },
    ...(isCustomCertificate
      ? {}
      : {
          cpd_points: {
            presence: true,
          },
        }),
    vimeo_url: {
      ...(object.webinar_type === "recorded"
        ? {
            presence: {
              message:
                "^Vimeo uid should contain only digits with up to 9 length",
            },
          }
        : {}),
    },
    audio_link: {
      ...(object.webinar_type === "audio"
        ? { presence: { message: "^Audio link should be present" } }
        : {}),
    },
    // disciplines: {
    //   presence: {
    //     message: '^Disciplines can\'t be blank'
    //   },
    //   length: {
    //     minimum: 1,
    //     message: '^Disciplines can\'t be blank'
    //   },
    // },
    ...(object.cpd_status === CPD_STATUSES.granted &&
    object.ref_type === REF_TYPES.ICGP
      ? {
          gms_study_days: {
            presence: {
              allowEmpty: false,
            },
          },
        }
      : {}),
  };

  if (object.cpd_status !== CPD_STATUSES.granted) {
    return constraints;
  }

  const cpdNumberValidation = {
    presence: {
      allowEmpty: false,
      message: "^Can’t be blank",
    },
    numericality: true,
  };

  const zoomIdValidation = {
    presence: true,
    format: {
      pattern: /^\d{5,}$/,
      message: "^Zoom uid should contain only digits with up to 9 length",
    },
  };

  switch (object.cpd_points) {
    case "internal":
      constraints = {
        ...constraints,
        ...(isCustomCertificate ? {} : { int_cpd_points: cpdNumberValidation }),
      };
      break;
    case "external":
      constraints = {
        ...constraints,
        ...(isCustomCertificate ? {} : { ext_cpd_points: cpdNumberValidation }),
      };
      break;
    case "both":
      constraints = {
        ...constraints,
        ...(isCustomCertificate
          ? {}
          : {
              int_cpd_points: cpdNumberValidation,
              ext_cpd_points: cpdNumberValidation,
            }),
      };
      break;
  }

  switch (object.webinar_type) {
    case "online":
      constraints = {
        ...constraints,
        zoom_uid: zoomIdValidation,
      };
      break;
    case "recorded":
      break;
  }

  return constraints;
};



// WEBPACK FOOTER //
// ./src/validators/groupWebinar.js